(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('reactReport', reactReport);
	
	reactReport.$inject = ['$scope', '$rootScope', 'uploadPOModalService'];

	function reactReport($scope, $rootScope, uploadPOModalService) {
		this.useReactReport = true;
		uploadPOModalService.setScopes($scope, $rootScope);
	}
})();
